/************************* Cancellation Policies *************************/
export const CANCELLATION_POLICIES_LOADING = 'CANCELLATION_POLICIES_LOADING';
export const CANCELLATION_POLICIES_SUCCESS = 'CANCELLATION_POLICIES_SUCCESS';
export const CANCELLATION_POLICIES_FAILURE = 'CANCELLATION_POLICIES_FAILURE';
